/* lua.js generated code 0.3.0 */

var ActivityButton = xClass("ActivityButton", function () {
    var __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/homeScene_icon_activity.csb")
})
ActivityButton.prototype.init = function () {
    var self = this
    var btn = UIButton.create(self.getChildByName("icon"))
    btn.on(UIButtonEvent.Click, handler(self, self.onOpenActivity))
    self.btn = btn
}
ActivityButton.prototype.onOpenActivity = function () { }
ActivityButton.create = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    var instance = ActivityButton.new()
    assert(instance)
    if (instance) {
        instance.init()
    }
    return instance
}
module.exports = ActivityButton
